import React, { useState } from 'react';
import { Button, Input, Select, Table, DatePicker, Col } from "antd";
import { useLocation, useHistory } from "react-router-dom";
import moment from 'moment';
import { SearchOutlined } from "@mui/icons-material";
import styled from "styled-components";
import { ReactComponent as Info } from "../../assets/Frame 2147225144.svg";
import ViewDetailsDisciplinary from "./ViewDetailsDisciplinary";


const Styleddiv = styled.div`
  .infostyle {
    margin-left: 5px;
    margin-top: -2px;
  }
  .total-ticket {
    font-size: 16px;
    font-weight: 400;
  }
  .head {
    color: #636980;
    font-size: 16px;
    font-weight: 400;
    cursor: pointer; 
  }
  .searchbar {
    width: 200px;
    height: 34px;
    border-radius: 24px;
  }
  .searchicon {
    color: #636980;
  }
  .date-dropdown .ant-select-selector {
    width: 200px;
    height: 34px;
    border-radius: 24px;
  }
  .date-dropdown:hover .ant-select-selector {
    border-color: #e2e2e8 !important;
  }
  .date-dropdown.ant-select-focused .ant-select-selector {
    border-color: #e2e2e8 !important;
  }
  .date-range-container {
    display: flex !important;
    gap: 10px;
  }
  .datepicker-style {
    width: 160px;
    height: 34px;
    border-radius: 24px;
  }
    .totaldiv{
    display:flex;
    justify-content:space-between;
    align-items:center;
    }
     .all-field-style {
    display: flex;
    gap: 10px;
  }
     .action-dropdown .ant-select-selector {
    width: 200px;
    height: 34px;
    border-radius: 24px;
  }
      .infostyle{
    margin-left:5px;
    margin-top:-2px;}
`;

function Categorytable() {
    const location = useLocation();
    const history = useHistory();
    const { category, employees } = location.state || { category: '', employees: [] };
    const [searchText, setSearchText] = useState("");
    const [selectedDateRange, setSelectedDateRange] = useState("");
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [actionValue, setActionValue] = useState("");
    const [showDateRange, setShowDateRange] = useState(false);
    const [selectedPath, setSelectedPath] = useState(null);
    const [selectedDisciplinary, setSelectedDisciplinary] = useState(null);
    const [diciplinaryrecord, setDisciplinaryRecord] = useState({});
    const [hoveredRow, setHoveredRow] = useState(null);

    const handleRowClick = (record) => {
        setSelectedPath(true);
        setSelectedDisciplinary(record);
        setDisciplinaryRecord(record);
    };

    const handleGoBack = () => {
        setSelectedPath(false);
    };
    const filterByDate = (data) => {
        const today = moment();
        return data.filter((item) => {
            const itemDate = moment(item.dateofincident, "YYYY-MM-DD");
            switch (selectedDateRange) {
                case "Last week":
                    return itemDate.isBetween(today.clone().subtract(1, "weeks").startOf("week"), today.clone().subtract(1, "weeks").endOf("week"));
                case "Last month":
                    return itemDate.isBetween(today.clone().subtract(1, "months").startOf("month"), today.clone().subtract(1, "months").endOf("month"));
                case "Last 6 months":
                    return itemDate.isBetween(today.clone().subtract(6, "months").startOf("month"), today.clone().endOf("month"));
                case "Custom Date range":
                    if (fromDate && toDate) {
                        return itemDate.isBetween(fromDate, toDate, null, "[]");
                    }
                    return true;
                case "all":
                default:
                    return true;
            }
        });
    };

    const filteredDispData = filterByDate(employees).filter((item) => {
        const searchTextLower = searchText.toLowerCase();
        const actionValueLower = actionValue ? actionValue.toLowerCase() : "";
        return (
            (item.disciplinaryId.toString().includes(searchTextLower) ||
                item.employee.toLowerCase().includes(searchTextLower) ||
                item.employeeId.toLowerCase().includes(searchTextLower)) &&
            (actionValueLower === "" || (item.actions && item.actions.toLowerCase().includes(actionValueLower)))
        );
    });

    const columns = [
        {
            title: "Discip. ID",
            dataIndex: "disciplinaryId",
            key: "disciplinaryId",
        },
        {
            title: "Name",
            dataIndex: "employee",
            key: "employee",
        },
        {
            title: "Employee ID",
            dataIndex: "employeeId",
            key: "employeeId",
        },
        {
            title: "Date of Incident",
            dataIndex: "dateofincident",
            key: "dateofincident",
            render: (text) => (text ? moment(text).format("Do MMMM YYYY") : "-"),
        },
        {
            title: "Action",
            dataIndex: "actions",
            key: "actions",
        },
        {
            title: "Moved to",
            dataIndex: "actiontimeline",
            key: "actionmoveon",
            render: (actiontimeline, record) => {
                const lastAction =
                    actiontimeline?.length > 0
                        ? actiontimeline[actiontimeline.length - 1]?.actionmoveon
                        : "-";

                const getColor = (action) => {
                    if (!action) return "black";

                    action = action.toLowerCase();
                    return action.includes("suspend")
                        ? "#2D53DA"
                        : action.includes("first") || action.includes("second") || action.includes("verbal")
                            ? "#119DE5"
                            : action.includes("third") || action.includes("show cause")
                                ? "#F28916"
                                : action.includes("demotion")
                                    ? "#8E2A5E"
                                    : action.includes("exoneration") || action.includes("clearance")
                                        ? "#22AD22"
                                        : action.includes("termination")
                                            ? "#D90325"
                                            : " #636980";
                };

                return (
                    <span
                        style={{
                            color: getColor(lastAction),
                            cursor: lastAction.toLowerCase() === "suspend" ? "pointer" : "default",
                            textDecoration: lastAction.toLowerCase() === "suspend" ? "underline" : "none",
                        }}
                    >
                        {lastAction}
                        {lastAction.toLowerCase() === "suspend" && <Info className="infostyle" />}
                    </span>
                );
            },
        },
        {
            title: "Created on",
            dataIndex: "updatedAt",
            key: "updatedAt",
            render: (text) => (text ? moment(text).format("Do MMMM YYYY") : "-"),
        },
        {
            title: "Created by",
            dataIndex: "createdByUserName",
            key: "createdByUserName",
        }
    ];

    const data = filteredDispData.map((employee, index) => ({
        key: index,
        disciplinaryId: employee.disciplinaryId,
        employee: employee.employee,
        employeeId: employee.employeeId,
        dateofincident: employee.dateofincident,
        actions: employee.actions,
        actiontimeline: employee.actiontimeline,
        updatedAt: employee.updatedAt,
        createdByUserName: employee.createdByUserName,
    }));

    const handleSelectChange = (value) => {
        setSelectedDateRange(value);
        if (value === "Custom Date range") {
            setShowDateRange(true);
        } else {
            setShowDateRange(false);
            setFromDate(null);
            setToDate(null);
        }
    };



    return (
        <Styleddiv>
            {!selectedPath && (
                <>
                    <div className='total-ticket'>
                        <span className='head' onClick={() => history.goBack()}> {category} &gt;</span> View details
                    </div>
                    <br /><br />
                    <div className='totaldiv'>
                        <div className="total-ticket">
                            Total: {data.length}
                        </div>
                        <div className="all-field-style">
                            <div>
                                <Input
                                    className="searchbar"
                                    placeholder="Search"
                                    prefix={<SearchOutlined className="searchicon" />}
                                    value={searchText}
                                    onChange={(e) => setSearchText(e.target.value)}
                                />
                            </div>
                            <div>
                                <Select
                                    placeholder="Date"
                                    className="date-dropdown"
                                    onChange={handleSelectChange}
                                    allowClear
                                >
                                    <Select.Option value="Last week">Last week</Select.Option>
                                    <Select.Option value="Last month">Last month</Select.Option>
                                    <Select.Option value="Last 6 months">Last 6 months</Select.Option>
                                    <Select.Option value="Custom Date range">Custom Date range</Select.Option>
                                </Select>
                            </div>
                            {showDateRange && (
                                <div className="date-range-container">
                                    <Col>
                                        <div>
                                            <DatePicker
                                                placeholder="From"
                                                format="DD-MM-YYYY"
                                                className="datepicker-style"
                                                onChange={(date) => setFromDate(date)}
                                            />
                                        </div>
                                    </Col>
                                    <Col>
                                        <div>
                                            <DatePicker
                                                placeholder="To"
                                                format="DD-MM-YYYY"
                                                className="datepicker-style"
                                                onChange={(date) => setToDate(date)}
                                                disabledDate={(current) =>
                                                    fromDate ? current && current.isBefore(fromDate, "day") : false
                                                }
                                            />
                                        </div>
                                    </Col>
                                </div>
                            )}

                            <Col
                                className={`dropdown-container ${showDateRange ? "adjust-margin" : ""
                                    }`}
                            >
                                <div>
                                    <Select
                                        placeholder="Action"
                                        className="action-dropdown"
                                        onChange={(value) => setActionValue(value)}
                                        allowClear
                                    >
                                        <Select.Option value="Verbal Warning">
                                            Verbal Warning
                                        </Select.Option>
                                        <Select.Option value="First Warning">
                                            First Warning
                                        </Select.Option>
                                        <Select.Option value="Second Warning">
                                            Second Warning
                                        </Select.Option>
                                        <Select.Option value="Third & Final Warning">
                                            Third & Final Warning
                                        </Select.Option>
                                        <Select.Option value="Show Cause">
                                            Show Cause
                                        </Select.Option>
                                        <Select.Option value="Suspend">Suspend</Select.Option>
                                        <Select.Option value="Demotion">Demotion</Select.Option>
                                        <Select.Option value="exoneration">
                                            Exoneration
                                        </Select.Option>
                                        <Select.Option value="Clearance">Clearance</Select.Option>
                                        <Select.Option value="Termination">
                                            Termination
                                        </Select.Option>
                                    </Select>
                                </div>
                            </Col>
                        </div>
                    </div>
                    <br />
                    <Table
                        columns={columns}
                        dataSource={data}
                        pagination={false}
                        onRow={(record) => ({
                            onMouseEnter: () => setHoveredRow(record.disciplinaryId), // Use `disciplinaryId`
                            onMouseLeave: () => setHoveredRow(null),
                            className: hoveredRow === record.disciplinaryId ? "hover-row" : "",
                            onClick: (e) => {
                                e.stopPropagation();
                                handleRowClick(record);
                            },
                        })}
                    />
                </>
            )}
            {selectedPath && diciplinaryrecord && (
                <ViewDetailsDisciplinary record1={diciplinaryrecord} id={diciplinaryrecord?.disciplinaryId} category={category}
                    employeeName={diciplinaryrecord?.employee} setSelectedPath={setSelectedPath} />
            )}
        </Styleddiv>
    );
}

export default Categorytable;